// src/components/ui/TruncatedText/TruncatedText.jsx
// Single-line text with an ellipsis; shows a small tooltip with the full text only when it is actually truncated.
import React, { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './TruncatedText.module.css';

const TruncatedText = ({ text, className = '' }) => {
  const ref = useRef(null);
  const [tooltip, setTooltip] = useState(null);

  const show = () => {
    const el = ref.current;
    if (!el || el.scrollWidth <= el.clientWidth) return;
    const rect = el.getBoundingClientRect();
    setTooltip({ top: rect.top, left: rect.left + rect.width / 2 });
  };

  const hide = () => setTooltip(null);

  return (
    <>
      <span
        ref={ref}
        className={`${styles.truncated} ${className}`}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
      >
        {text}
      </span>
      {tooltip && createPortal(
        <span role="tooltip" className={styles.tooltipBubble} style={{ top: tooltip.top, left: tooltip.left }}>
          {text}
        </span>,
        document.body
      )}
    </>
  );
};

export default TruncatedText;
